import React, {useState, useEffect} from 'react';
import './Justificantes.css';
import api from '../../../services/api';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faClipboard } from '@fortawesome/free-solid-svg-icons'
import studentImage from '../../../images/student_portrait.svg'

const Reportes = () => {
    const [showMessage, setShowMessage] = useState(false);
    const [tipoJustificante, setTipoJustificante] = useState([]);
    const [justificacion, setJustificacion] = useState([]);

    const [showInfo, setShowInfo] = useState(false);
    const [infoAlumno, setInfoAlumno] = useState([]);
    const [alumnoSeleccionadoFocus, setAlumnoSeleccionadoFocus] = useState([]);
    const [fotoAlumno, setFotoAlumno] = useState();

    const [showSearch, setShowSearch] = useState(false);
    const [listaAlumnos, setListaAlumnos] = useState([]);
    const [alumno, setAlumno] = useState([]);
    
    const [alumnos, setAlumnos] = useState([]);
    const [alumnosSeleccionados, setAlumnosSeleccionados] = useState([]);
    const [turno, setTutno] = useState(1);
    const [grado, setGrado] = useState(1);
    const [grupo, setGrupo] = useState(null);

    const [idJustificante, setIdJustificante] = useState(1);
    const [idMotivo, setIdMotivo] = useState(1);
    const [mensaje, setMensaje] = useState("");
    const [fechaInicial, setFechaInicial] = useState("");
    const [fechaFinal, setFechaFinal] = useState("");
    const [horas, setHoras] = useState(0);
    const [personalAtiende, setPersonalAtiende] = useState("");
    const [idTutor, setIdTutor] = useState("");
    const [nombreTutor, setNombreTutor] = useState("");
    const [telefono, setTelefono] = useState("");

    const buttonDisable = {
        cursor: "not-allowed",
        opacity: "0.5",
        pointerEvents: "none",
    }

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response =  await api.getTipoJustificante();
                setTipoJustificante(response.data.data);
                const responseJus =  await api.getJustificacion();
                setJustificacion(responseJus.data.data);

            } catch (error) {
                
            }
        };

        const fotoAlumno = async () => {
            try {
                const MATRICULA = alumnosSeleccionados[0].MATRICULA;
                const response = await api.getFotoAlumno({MATRICULA});
                const FOTO = response.data.data.FOTO;

                const arrayBuffer = new Uint8Array(FOTO.data);
                const base64String = btoa(
                  arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            } catch (error) {
                setFotoAlumno(studentImage);

            }
        };

        try {
            setAlumnoSeleccionadoFocus(alumnosSeleccionados[0]);
            fotoAlumno();
        } catch (error) {
        }

        fetchData();
    }, [alumnosSeleccionados]);

    const buscar1Alumno = async () => {
        setShowSearch(true);    
        try {
            const response = await api.getAlumnosAsistencias({alumno});
            setListaAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const buscarAlumnos = async () => {
        try {
            const response = await api.getAlumnosList({turno, grado, grupo});
            setAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const registrarJustificante = async () => {
        try {
            const response = await api.postRegistrarJustificante({alumnosSeleccionados, idJustificante, idMotivo, mensaje, fechaInicial, fechaFinal, horas, personalAtiende, idTutor, nombreTutor, telefono});
            if (response.data.success) {
                swal("¡Éxito!", "Los justificantes se registraron correctamente.", "success");
            }
            else{
                swal("Error", "Intente de nuevo más tarde.", "error");
            }
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    async function verInfoAlumno(alumno) {
        const MATRICULA = alumno.MATRICULA;
        try {
            setShowInfo(true);
            const response = await api.getInfoAlumnoCompleta({MATRICULA})
            setInfoAlumno(response.data.data);
            
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }

        try {
            
            const response = await api.getFotoAlumno({MATRICULA});
            const FOTO = response.data.data.FOTO;

            const arrayBuffer = new Uint8Array(FOTO.data);
            const base64String = btoa(
              arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            
        } catch (error) {
            setFotoAlumno(studentImage);
        }
    }

    async function agregarAlumno(alumno) {
        setAlumnosSeleccionados((prevAlumnos) => [...prevAlumnos, alumno]);
        setAlumnos((prevAlumnos) => prevAlumnos.filter((a) => a.MATRICULA !== alumno.MATRICULA));
        setShowSearch(false);
    }

    async function eliminarAlumno(alumno) {
        setAlumnos((prevAlumnos) => [...prevAlumnos, alumno]);
        setAlumnosSeleccionados((prevAlumnos) => prevAlumnos.filter((a) => a.MATRICULA !== alumno.MATRICULA));
    }

    async function handleSeleccionarAlumnoFocus(matricula) {
        const alum = alumnosSeleccionados.find(alumno => alumno.MATRICULA === matricula);
        setAlumnoSeleccionadoFocus(alum);

        try {
            const response = await api.getFotoAlumno({MATRICULA: matricula});
            const FOTO = response.data.data.FOTO;

            const arrayBuffer = new Uint8Array(FOTO.data);
            const base64String = btoa(
              arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            
        } catch (error) {
            setFotoAlumno(studentImage);
        }
    }

    function handleTutoAlumno(id_tutor) {
        setIdTutor(id_tutor);
        if (id_tutor === '0') {
            setNombreTutor(alumnoSeleccionadoFocus.NOMBRE_PADRE);
        } else if (id_tutor === '1') {
            setNombreTutor(alumnoSeleccionadoFocus.NOMBRE_MADRE);
        } else {
            setNombreTutor('');
        }
    }

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-filtros'>
                    <div className='container-filtros-tabla'>
                        <div className='filtros-input'>
                            <label>Turno</label>
                            <select name="Turno" onChange={e => (setTutno(e.target.value))}>
                                <option value="1" defaultChecked>MATUTINO</option>
                                <option value="2">VESPERTINO</option>
                            </select>
                        </div>
                        <div className='filtros-input'>
                            <label>Grado</label>
                            <select name="Grado" onChange={e => (setGrado(e.target.value))}>
                                <option value="1" defaultChecked>PRIMERO</option>
                                <option value="2">SEGUNDO</option>
                                <option value="3">TERCERO</option>
                            </select>
                        </div>
                        <div className='filtros-input'>
                            <label>Grupo</label>
                            <input type="number" onChange={ e => (setGrupo(e.target.value))}></input>
                        </div>
                        <div className='asistencia-buscar'>
                            <label htmlFor='student-name'>Nombre del Alumno:</label>
                            <input type='text' name='student-name' value={alumno} onChange={e => {setAlumno(e.target.value)}}
                                style={{fontSize: '20px', height: '20px'}}></input>
                        </div>
                    </div>
                    <div className='buscar-envio-mensaje'>
                        <button onClick={buscarAlumnos}>BUSCAR</button>
                        <button onClick={buscar1Alumno} className='button-buscar-alumno'>BUSCAR ALUMNO</button>
                    </div>
                    <div className='button-enviar-mensaje'>
                        <button onClick={e => setShowMessage(true)} style={alumnosSeleccionados.length > 0 ? {} : buttonDisable}>HACER JUSTIFICANTE</button>
                    </div>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "contenedor-tabla-mensajes">
                            <table className= "tabla-mensajes lista-mensajes">
                                <thead>
                                    <tr>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                    </tr>
                                </thead>
                                <tbody className='select-pointer'>
                                    { alumnos && alumnos.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i } onClick={e => agregarAlumno(alumno)}>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.NOMBRE }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <table className= "tabla-mensajes alumnos-seleccionados">
                                <thead>
                                    <tr>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>INFO</label></th>
                                        <th><label>ELIMINAR</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { alumnosSeleccionados && alumnosSeleccionados.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i }>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.NOMBRE }</td>
                                            <td><label className='select-pointer-Info' onClick={e => verInfoAlumno(alumno)}><FontAwesomeIcon icon={faClipboard} /></label></td>
                                            <td><label className='select-pointer-X' onClick={e => eliminarAlumno(alumno)} ><FontAwesomeIcon icon={faTrash} /></label></td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showSearch ? <>
            <div className="overlay"></div>
            <div className='container-buscar-alumno'>
                <div className='title-buscar-alumno'>
                    <h3>SELECCIONA AL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowSearch(false)}> X </label>
                </div>
                <div className='container-table-buscar-alumno'>
                    <table className='table-buscar-alumno'>
                        <thead>
                            <tr>
                                <th><label>MATRICULA</label></th>
                                <th><label>ALUMNO</label></th>
                                <th><label>TURNO</label></th>
                                <th><label>GRADO</label></th>
                                <th><label>GRUPO</label></th>
                            </tr>
                        </thead>
                        <tbody>
                            { listaAlumnos && listaAlumnos.map( (alumno, i) => { 
                                return (
                                <tr key={ i } onClick={e => agregarAlumno(alumno)}>
                                    <td>{ alumno.MATRICULA }</td>
                                    <td>{ alumno.ALUMNO }</td>
                                    <td>{ alumno.NIVEL }</td>
                                    <td>{ alumno.ID_GRADO }</td>
                                    <td>{ alumno.GRUPO }</td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </> : ''}
        { showMessage ? <>
            <div className='overlay'></div>
            <div className='container-reporte'>
                <div className='titulo-reporte'>
                    <h3>GENERA EL JUSTIFICANTE</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowMessage(false)}> X </label>
                </div>
                <div className='container-img-reporte'>
                    <div className='data'>
                        <div className='container-data-reporte'>
                            <div className="data-group-nombre">
                                <label>Nombre del Alumno</label>
                                <p>{alumnoSeleccionadoFocus.NOMBRE}</p>
                                <p className='turno'>MATUTINO</p>
                            </div>
                        </div>
                        <div className='container-data-reporte-nombre'>
                            <div className="data-group-alumnos">
                                <label>Alumnos:</label>
                                <select id="reporte-alumno" name="reporte-alumno" value={alumnoSeleccionadoFocus.MATRICULA} onChange={e => handleSeleccionarAlumnoFocus(e.target.value)}>
                                    { alumnosSeleccionados && alumnosSeleccionados.map( (alumno, i) => {
                                        return (
                                            <option value={alumno.MATRICULA} key={i}>{alumno.NOMBRE}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <img src={fotoAlumno} alt="foto-alumno-reporte" />
                </div>
                <div className='container-registrar-justificantes'>
                    <h4>Tipo de Justificante</h4>
                    <div className='container-tipo-justificante'>
                        <label>De la manera mas atenta se les solicita:</label>
                        <select id='tipo-solicitud' value={idJustificante} onChange={e => setIdJustificante(e.target.value)}>
                            { tipoJustificante && tipoJustificante.map((tipo, i) => {
                                return (
                                    <option value={tipo.Id} key={i}>{tipo.Descripcion}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className='container-registrar-justificantes'>
                    <h4>Justificante para Faltas y/o Pase de Salidas</h4>
                    <div className='container-tipo-justificante'>
                        <label>Selecciona el motivo del justificante:</label>
                        <select id='justificacion' value={idMotivo} onChange={e => setIdMotivo(e.target.value)}>
                            { justificacion && justificacion.map((justificacion, i) => {
                                return (
                                    <option value={justificacion.Id_Justificante} key={i}>{justificacion.Justificante}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className='container-registrar-justificantes-datos'>
                    <h4>Datos del Justificante</h4>
                    <div className='container-datos-justificante-fecha'>
                        <label>Fecha a Justificar del:</label>
                        <input type='date' value={fechaInicial} onChange={e => setFechaInicial(e.target.value)}></input>
                        <label>al:</label>
                        <input type='date' value={fechaFinal} onChange={e => setFechaFinal(e.target.value)}></input>
                        <label>Durante:</label>
                        <input type='number' value={horas} onChange={e => setHoras(e.target.value)}></input>
                        <label>Horas</label>
                    </div>
                    <div className='container-datos-justificante'>
                        <label>Personal que Atiende:</label>
                        <input type='text' value={personalAtiende} name='PersonalAtiende' 
                        placeholder='Deje en blanco para usar el usuario por defecto' onChange={e => setPersonalAtiende(e.target.value)}></input>
                    </div>
                    <div className='container-datos-justificante'>
                        <label>Padre o Tutor:</label>
                        <input type='text' value={nombreTutor} onChange={e => setNombreTutor(e.target.value)}></input>
                        <div className='radio-container'>
                            <label><input type='radio' name='tutor' value={0} onChange={e => handleTutoAlumno(e.target.value)}></input> Asignar al Padre</label>
                            <label><input type='radio' name='tutor' value={1} onChange={e => handleTutoAlumno(e.target.value)}></input> Asignar a la Madre</label>
                            <label><input type='radio' name='tutor' value={2} onChange={e => handleTutoAlumno(e.target.value)}></input> Otro Tutor</label>
                        </div>
                    </div>
                    <div className='container-datos-justificante'>
                        <label>Télefono:</label>
                        <input type='text' value={telefono} onChange={e => setTelefono(e.target.value)}></input>
                    </div>
                    <div className='container-datos-justificante'>
                        <label>Comentarios:</label>
                        <input type='text' className='comentarios' value={mensaje} onChange={e => setMensaje(e.target.value)}></input>
                    </div>
                </div>
                <div className='container-buttons-justificante'>
                    <div className='button-enviar-mensaje'>
                        <button onClick={registrarJustificante}>JUSTIFICAR</button>
                    </div>
                </div>
            </div>
        </> : ''}
        { showInfo ? <>
            <div className='overlay'></div>
            <div className='container-info-reporte'>
                <div className='titulo-message'>
                    <h3>INFORMACIÓN DEL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowInfo(false)}> X </label>
                </div>
                <hr></hr>
                <div className='container-data-reporte'>
                    <div className="data-alumno-reporte">
                        <div className='data-info-alumno-reporte-img'>
                            <img src={fotoAlumno} alt="foto-alumno-reporte" />
                        </div>
                        <label>Matricula: <p>{infoAlumno.MATRICULA}</p></label>
                        <label>Nombre: <p>{infoAlumno.NOMBRE}</p></label>
                        <label>Turno: <p>{infoAlumno.NIVEL}</p></label>
                        <label>Grado y Grupo: <p>{infoAlumno.ID_GRADO + " " + infoAlumno.GRUPO}</p></label>
                    </div>
                    <div className="container-info-alumno-reporte">
                        <div className="data-info-alumno-reporte">
                            <h3>Datos del Padre</h3>
                            <label>Nombre: <p>{infoAlumno.NOMBRE_PADRE}</p></label>
                            <label>Profesión: <p>{infoAlumno.PROFESION_PADRE}</p></label>
                            <label>Trabajo: <p>{infoAlumno.TRABAJO_PADRE}</p></label>
                            <label>Teléfono: <p>{infoAlumno.TELEFONO_PADRE}</p></label>
                        </div>
                        <div className="data-info-alumno-reporte">
                            <h3>Datos de la Madre</h3>
                            <label>Nombre: <p>{infoAlumno.NOMBRE_MADRE}</p></label>
                            <label>Profesión: <p>{infoAlumno.PROFESION_MADRE}</p></label>
                            <label>Trabajo: <p>{infoAlumno.TRABAJO_MADRE}</p></label>
                            <label>Teléfono: <p>{infoAlumno.TELEFONO_MADRE}</p></label>
                        </div>
                        <div className="data-info-alumno-reporte">
                            <h3>Domicilio Familiar</h3>
                            <label>Calle y Número: <p>{infoAlumno.DOMICILIO}</p></label>
                            <label>Colonia y CP: <p>{infoAlumno.COLONIA + " " + infoAlumno.CP}</p></label>
                            <label>Localidad: <p>{infoAlumno.LOCALIDAD}</p></label>
                            <label>Teléfono Casa: <p>{infoAlumno.TELEFONO_CASA}</p></label>
                        </div>
                    </div>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default Reportes;